import jsPDF from 'jspdf';

export default function generateReceiptPdf(
  receiptLines,
  { filename = 'receipt.pdf', lineHeight = 5, paperWidth = 72 } = {}
) {
  const sizeMap = { normal: 9, double: 12 };
  const basePadding = 20;
  const height = basePadding + receiptLines.length * lineHeight;

  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: [paperWidth, height],
  });

  let y = 10;

  receiptLines.forEach(({ text = '', align = 'left', fontSize = 'normal', bold = false }) => {
    if (text === undefined || text === null) text = '';

    doc.setFontSize(sizeMap[fontSize] ?? 9);
    doc.setFont('helvetica', bold ? 'bold' : 'normal');

    let x = 5;
    if (align === 'center') x = paperWidth / 2;
    if (align === 'right')  x = paperWidth - 4;

    doc.text(String(text), x, y, {
      align: align === 'center' ? 'center' : align,
    });

    y += lineHeight;
  });

  const blob   = doc.output('blob');
  const url    = URL.createObjectURL(blob);
  window.open(url, '_blank');

  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 2300);

  doc.save(filename);
}
